module.exports = __webpack_public_path__ + "static/media/ready.784942e2.mp3";